import {RecipePart} from "./recipePart";
import { Timestamp } from '@firebase/firestore';

export class Recipe {

  id: string;
  name: string;
  description: string;
  parts: RecipePart[];
  nrOfPeople: number;
  path: string;
  downloadURL: string;
  totalDuration: number;
  author: string;
  authorUid: string;
  creationDate: Timestamp;
  labels: string[];

  constructor(obj: {
    id?: string,
    name?: string,
    description?: string,
    parts?: RecipePart[],
    nrOfPeople?: number,
    path?: string,
    downloadURL?: string,
    totalDuration?: number,
    author?: string,
    authorUid?: string,
    creationDate?: Timestamp;
    labels?: string[]
  }) {
    this.id = obj.id || null;
    this.name = obj.name || null;
    this.description = obj.description || null;
    this.parts = [];
    if (obj.parts)
      obj.parts.forEach(part => this.parts.push(new RecipePart(part)));
    this.nrOfPeople = obj.nrOfPeople || 4;
    this.path = obj.path || null;
    this.downloadURL = obj.downloadURL || null;
    this.totalDuration = obj.totalDuration || null;
    this.author = obj.author || null;
    this.authorUid = obj.authorUid || null;
    this.creationDate = obj.creationDate || null;
    this.labels = [];
    if (obj.labels)
      obj.labels.forEach(step => this.labels.push(step))
  }

  getTotalNrOfMinutes(): number {
    let minutes = 0;
    this.parts.forEach(part => minutes += part.duration);
    return minutes;
  }

}
